import React, {Component} from 'react';
import { Row, Col, FormControl } from 'react-bootstrap'
import FontAwesome from 'react-fontawesome'
import TextFieldModal from 'component/element/TextFieldModal'
import WorkdocStore from 'stores/WorkdocStore';
import facebook_icon from '../../../asset/img/facebook-icon-preview-1.png';
import line_icon from '../../../asset/img/LINE_Icon.png';
import truck from '../../../asset/img/truck.png';
import red_car from '../../../asset/img/red-car.png';
import fuelgaugeSrc from 'asset/img/fuelgauge3-150.png';
import PrintPreview from '../PrintPreview';
import PdfStore from 'stores/PdfStore';

var NotificationSystem = require('react-notification-system');

const truckTitleList = ['กันชนเสริมหน้า','กันชนสาดประตู','กันสาดแค็ป','กันแมลงฝากระโปรงหน้า','แมล็กไลน์เนอร์','กันชนเสริมหลัง','วิทยุเทป-ซีดี',
'แบตเตอรี่','ยางอะไหล่','เครื่องมือ','แม่แรง','กุญแจรถยนต์','ผ้าปูพื้น','ป้ายทะเบียน','โครเมี่ยมครอบไฟหน้า L/R',
'โครเมี่ยมครอบไฟหลัง L/R']
const sedanTitleList = ['เสากันสาดประตู','วิทยุเทป-ซีดี','แบตเตอรี่','ยางอะไหล่','เครื่องมือ','แม่แรง','กุญแจรถยนต์','ผ้าปูพื้น','ป้ายทะเบียน',
'โครเมี่ยมครอบไฟหน้า L/R','โครเมี่ยมครอบไฟหลัง L/R','ถาดรองห้องสัมภาระท้าย']
const damageTitleList = ['ระบบแอร์','ระบบไฟ','ระบบแตร','ระบบวิทยุ-ซีด','ไฟใหญ่หน้า/ไฟหรี่','ไฟตัดหมอกหน้า/หลัง','ไฟท้าย/ไฟถอย/ไฟเบรค',
'ไฟเบรคฝาท้ายหลังคา','กระจกประตู','กระจกมองข้าง','กุญแจ-รีโมท','ไฟส่องป้ายทะเบียนหลัง','ก้านปัด/ปุ่มฉีดน้ำฝน']

const bodyDamageTitleList = ['กันชนหน้า','กันชนหลัง','ฝากระโปรงหน้า','บังโคลนหน้า','บังโคลนหลัง','ประตูหน้า','ประตูหลัง','กระจกประตูหน้า',
'สเกิ้ตหน้า','สเกิ้ตหลัง','หลังคา','บันได','กระจกมองข้าง']
class PrintSSTParkingCarDoc extends Component {

  constructor(...args){
    super(...args)
    this.state = {loading:false, data:{car:{car_registration_no:'',brand:'',model:''},pdf_config:{extra_remark:''},
    insurer:{insurer_id:'',insurer_name:''},
    receiving:{entrance_date:'',entrance_name:'',title:'',entrance_name_as:'',tel:''},
    related_detail:{asset_check:truckTitleList.map((item,index)=>{
      return {exist:undefined,quantity:''}
    }),damage_check:damageTitleList.map((item,index)=>{
      return {normal:undefined}
    }),body_damage_check:bodyDamageTitleList.map((item,index)=>{
      return {position:undefined}
    }),remarklist:['',''],fuel_gauge:{fuel:{x:'',y:''}}}}}

    var cssPagedMedia = (function() {
      var style = document.createElement('style');
      document.head.appendChild(style);
      return function (rule) {
        style.innerHTML = rule;
      };
    }());

    cssPagedMedia.size = function(size) {
      cssPagedMedia('@page {size: ' + size + '}');
    };
    cssPagedMedia.size('portrait');
  }

  componentDidMount(){
    this._notificationSystem = this.refs.notificationSystem;
    this.loadParkingcarDoc()
  }

  loadParkingcarDoc() {
    let {workNo} = this.props

    this.setState({ loading: true })
    PdfStore.loadParkingcarDoc(workNo,(result)=> {
      let data = result.data
      data['related_detail'] = Object.assign(this.state.data.related_detail,data.related_detail)
      data = Object.assign(this.state.data,data)
      this.setState({loading:false,data:data})
      this.setFuelgauge(data.related_detail.fuel_gauge)
    })  
  }

  saveParkingcarDoc(data){
    let {workNo} = this.props

    WorkdocStore.saveWorkdocRelated(workNo,'parking_doc',data.related_detail,(result)=>{
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'ทำการบันทึกรายละเอียดเอกสารประกอบเลขงานซ่อม ' + workNo + ' เรียบร้อย',
        level: 'info',
        position: 'tc',        
      });
    },()=>{
      this._notificationSystem.addNotification({
        title: 'แจ้งเตือน',
        message: 'มีความผิดพลาดเกิดขึ้นในการบันทึกเอกสารประกอบเลขงานซ่อม ' + workNo + ' ',
        level: 'error',
        position: 'tc'
      });
    })
  }

  setFuelgauge(fuel_gauge) {

    const contextFuelgauge = this.canvasFuelgauge.getContext('2d')
    const imageFuelgauge = new Image()
    imageFuelgauge.src = fuelgaugeSrc
    imageFuelgauge.onload = () => {
      contextFuelgauge.drawImage(imageFuelgauge, 0, 0, this.canvasFuelgauge.width, this.canvasFuelgauge.height)
      this.setDrawLine(fuel_gauge)
    }
  }

  setDrawLine(fuel_gauge) {
    const context = this.canvasFuelgauge.getContext('2d')
    const imageFuelgauge = new Image()
    imageFuelgauge.src = fuelgaugeSrc
    context.drawImage(imageFuelgauge, 0, 0, 100, 50);

    var r = this.canvasFuelgauge.getBoundingClientRect();
    var x = fuel_gauge.fuel['x']
    var y = fuel_gauge.fuel['y']
    if (x!=""&&y!="") {
      context.beginPath();
      context.moveTo(x, y);
      context.lineTo(50, 50);
      context.lineWidth = 5;

      context.strokeStyle = '#ff0000';
      context.stroke();
    }     
  }

  onDrawLine(e) {
    let {data} = this.state
    let {fuel_gauge} = data.related_detail
    var r = this.canvasFuelgauge.getBoundingClientRect();
    var x = e.clientX - r.left;
    var y = e.clientY - r.top;


    fuel_gauge.fuel['x'] = x
    fuel_gauge.fuel['y'] = y

    this.setFuelgauge(fuel_gauge);

    this.setState({data:data})

    this.saveParkingcarDoc(data)
  }

  renderFuelgauge() {
    return(
      <div>                
        <canvas
          onClick={this.onDrawLine.bind(this)}
          ref={canvasFuelgauge => this.canvasFuelgauge = canvasFuelgauge}
          width="100" height="50">
          <p>Error</p>
        </canvas>
      </div>
    )
  }

  renderLogoUrl(logoUrl){
    if(logoUrl===undefined){
      return ('')
    }
    let imgUrl = ''
    if (process.env.NODE_ENV == "development") {
      imgUrl = 'https://demo2.bigfix.co/korat/pdf/'+logoUrl
    }else{
      imgUrl = '../'+logoUrl
    }
    return (<img src={imgUrl} style={{maxWidth:'100px'}}/>)
  }

  renderEntraneAs(receiving){
    if(receiving.entrance_name_as==='owner'){
      return (<span>ผู้ครอบครอง</span>)
    }else if(receiving.entrance_name_as==='driver'){
      return (<span>ผู้ขับขี่</span>)
    }else{
      return (<span><br /></span>)
    }
  }

  renderAdditionalText(data){
    if(data.additional_text!==undefined){
      return (<p style={{lineHeight:'0.7'}}>{data.additional_text} </p>)
    }else{
      return ('')
    }
  }

  renderOpenText(data){
    if(data.open_text!==undefined){
      return (<span>{data.open_text}</span>)
    }else{
      return (<span>08.30-17.30</span>)
    }
  }

  renderExtraRemark(data){
    if(data.extra_remark!==undefined){
      return (<span>{data.extra_remark}</span>)
    }else{
      return ('')
    }
  }

  renderComponentPage() {
    let {data} = this.state
    let {mode,title} = this.props
    let {receiving,car,insurer} = data
    let {asset_check,damage_check,body_damage_check,remarklist} = data.related_detail
    return(
      <div className='font-print'>
        <header>
          <h2 className="text-right">{mode==='2'?'ใบรับรถไม่จอดซ่อม':title}</h2>
        </header>  
        <article className={"article-company "+data.logo_class}>
          <div style={{width:data.logo_width+'px',textAlign:'center',lineHeight:'70px'}}>
            {this.renderLogoUrl(data.logo_url)}
          </div>
          <section className="font-20" style={{paddingTop:(data.logo_class=='bg-logo-absolute'?'0px':'0')}}>
            <strong>
              <p style={{lineHeight:'0.7'}}>{data.company_name} ({data.company_branch})</p>
              <p style={{lineHeight:'0.7'}}>{data.company_addr} </p>
              <p style={{lineHeight:'0.7'}}>โทร {data.company_tel} โทรสาร {data.company_fax}</p>
              {this.renderAdditionalText(data)}
            </strong>
          </section>
        </article>
        <br/>
        <br/>
        <div className='box-sst-parking-car-doc'>
          <table className='table table-sst-parking-car-doc'>
            <tbody>
              <tr>
                <td className='text-left'>
                  {/* รถเข้าระหว่างวันที่...{receiving.entrance_date}...ชื่อ...{receiving.title}..{receiving.entrance_name}...........เป็น.....{this.renderEntraneAs(receiving)}........ */}
                  รถเข้าระหว่างวันที่ <span style={{width:'110px',borderBottom:'2px dotted #111',display:'inline-block'}}>{receiving.entrance_date?receiving.entrance_date:<br />}</span> &nbsp;
                  ชื่อ <span style={{width:'150px',borderBottom:'2px dotted #111',display:'inline-block'}}>{receiving.title?receiving.title:<br />} {receiving.entrance_name}</span> &nbsp;
                  เป็น <span style={{width:'120px',borderBottom:'2px dotted #111',display:'inline-block'}}>{this.renderEntraneAs(receiving)}</span>
                </td>
              </tr>
            </tbody>
          </table>  
          <table className='table table-sst-parking-car-doc'>
            <tbody>
              <tr>
                <td className='text-left'>
                  {/* {insurer.insurer_id==='0'?'ชำระด้วย':'ประกันภัย'}...{insurer.insurer_name}...ยี่ห้อ ...{car.brand}/{car.model}... ทะเบียน ...{car.car_registration_no}................... */}
                  {insurer.insurer_id==='0'?'ชำระด้วย':'ประกันภัย'} <span style={{width:(insurer.insurer_name?'auto':'110px'),borderBottom:'2px dotted #111',display:'inline-block'}}>{insurer.insurer_name?insurer.insurer_name:<br />}</span> &nbsp;
                  ยี่ห้อ <span style={{width:'200px',borderBottom:'2px dotted #111',display:'inline-block'}}>{car.brand?car.brand:<br />}/{car.model}</span> &nbsp;
                  ทะเบียน <span style={{width:'150px',borderBottom:'2px dotted #111',display:'inline-block'}}>{car.car_registration_no?car.car_registration_no:<br />}</span>
                </td>
              </tr>
            </tbody>  
          </table>
          <table className='table table-sst-parking-car-doc'>
            <tbody>
              <tr>
                <td className='text-left' style={{position:'relative'}}>
                  {/* เบอร์โทรศัพท์...........{receiving.tel}..................
                  <img src={facebook_icon} width="38" height="38" /><img src={line_icon} width="38" height="38" />
                  .............................................................................. */}
                  เบอร์โทรศัพท์ <span style={{width:'110px',borderBottom:'2px dotted #111',display:'inline-block'}}>{receiving.tel?receiving.tel:<br />}</span> &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
                  <span className='text-center' style={{position:'absolute',top:'-18px',width:'200px',borderBottom:'2px dotted #111',display:'inline-block'}}>
                    <img src={facebook_icon} width="38" height="38" /><img src={line_icon} width="38" height="38" />
                  </span>
                </td>
              </tr>
            </tbody>  
          </table>
          <table className='table table-sub-sst-parking-car-doc'>
            <tbody>
              <tr>
                <td colSpan={1}>
                  <div className='text-center' style={{display:(['TRUCK','PICKUP'].includes(car.car_type))?'block':'none'}}><img  src={truck} width="100" height="40" /> <span className='font-30 color-pink'>รถกระบะ</span> </div>
                  <div className='text-center' style={{display:(['SEDAN','VAN','MINIVAN'].includes(car.car_type))?'block':'none'}}><img src={red_car} width="120" height="60" /> <span className='font-30 color-pink'>รถเก๋ง/รถตู้</span> </div>
                </td>
                <td className='text-center' style={{verticalAlign:'bottom'}}>ตำหนิความเสียหายนอกเหนือใบเคลม</td>
                <td className="text-center" style={{verticalAlign:'bottom'}}>ตรวจเช็คระบบไฟต่างๆ</td>
              </tr>
              <tr>
                <td style={{display:(['TRUCK','PICKUP'].includes(car.car_type))?'block':'none'}} >
                  <table className='table table-sub-sst-parking-car-doc table-bordered'>
                    <tbody>
                      <tr>
                        <td style={{width:'100px'}}>
                          อุปกรณ์ที่ติดมากับรถ
                        </td>
                        <td style={{width:'13px'}} className='text-center'>มี</td>
                        <td style={{width:'20px'}} className='text-center'>จำนวน</td>
                        <td style={{width:'20px'}} className='text-center'>ไม่มี</td>
                      </tr>
                      {truckTitleList.map((item,index)=>(
                        this.renderCarAsset(item,asset_check,index)
                      ))}                      
                    </tbody>
                  </table>
                </td>
                <td style={{display:(['SEDAN','VAN','MINIVAN'].includes(car.car_type))?'block':'none'}} >
                  <table className='table table-sub-sst-parking-car-doc table-bordered'>
                    <tbody>
                      <tr>
                        <td style={{width:'100px'}}>
                          อุปกรณ์ที่ติดมากับรถ
                        </td>
                        <td style={{width:'13px'}} className='text-center'>มี</td>
                        <td style={{width:'20px'}} className='text-center'>จำนวน</td>
                        <td style={{width:'20px'}} className='text-center'>ไม่มี</td>
                      </tr>
                      {sedanTitleList.map((item,index)=>(
                        this.renderCarAsset(item,asset_check,index)
                      ))}                       
                    </tbody>
                  </table>
                </td>
                
                <td>
                  <table className='table table-sub-sst-parking-car-doc'>
                    <tbody>
                    <tr>
                        <td style={{width:'100px'}}>
                          
                        </td>
                        <td style={{width:'30px'}} className='text-center'>ซ้าย</td>
                        <td style={{width:'30px'}} className='text-center'>ขวา</td>                        
                      </tr>
                      {
                        bodyDamageTitleList.map((item,index)=>(
                          <tr key={index}>                            
                            <td>{item}</td>
                            <td className='text-center'>
                              <span onClick={this.onBodyDamageClick.bind(this,'left',index)}>({body_damage_check[index].position&&['left','both'].includes(body_damage_check[index].position)?<FontAwesome name='check'/>:'.....'})</span>
                            </td>
                            <td>
                              <span onClick={this.onBodyDamageClick.bind(this,'right',index)} >({body_damage_check[index].position&&['right','both'].includes(body_damage_check[index].position)?<FontAwesome name='check'/>:'.....'})</span>
                            </td>               
                          </tr>
                        ))
                      }
                      <tr>                        
                        <td colSpan={3}>ตำหนิอื่นๆ</td>
                      </tr>
                      <tr>                        
                        <td colSpan={3} onClick={this.onDamageRemarkClick.bind(this,0)}>
                          {/* <span onClick={this.onDamageRemarkClick.bind(this,0)}>1...{this.renderDamageRemark(remarklist[0])}...</span> */}
                          1 <span style={{width:'80%',borderBottom:'2px dotted #111',display:'inline-block'}}>{this.renderDamageRemark(remarklist[0])}</span>
                        </td>
                      </tr>
                      <tr>                        
                        <td colSpan={3} onClick={this.onDamageRemarkClick.bind(this,1)}>
                          {/* <span onClick={this.onDamageRemarkClick.bind(this,1)}>2...{this.renderDamageRemark(remarklist[1])}...</span> */}
                          2 <span style={{width:'80%',borderBottom:'2px dotted #111',display:'inline-block'}}>{this.renderDamageRemark(remarklist[1])}</span>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
                <td>
                  <table className='table table-sub-sst-parking-car-doc'>
                    <tbody>
                      {
                        damageTitleList.map((item,index)=>(
                          <tr key={index}>
                            <td></td>
                            <td>{item}</td>
                            <td className='text-right'>
                              <span onClick={this.onDamageClick.bind(this,true,index)}>{damage_check[index].normal!==undefined&&damage_check[index].normal?<FontAwesome name='check'/>:'......'}ปกติ</span>
                              <span onClick={this.onDamageClick.bind(this,false,index)}>{damage_check[index].normal!==undefined&&!damage_check[index].normal?<FontAwesome name='check'/>:'......'}ไม่ปกติ</span></td>               
                          </tr>
                        ))
                      }                      
                      <tr>
                        <td></td>
                        <td className='text-center' colSpan={2}>
                          เลขไมล์กิโลเมตร___{car.mileage}__
                        </td>
                      </tr>
                      <tr>
                        <td></td>
                        <td className='text-center'>
                          ระดับน้ำมัน
                        </td>
                        <td>                          
                          {this.renderFuelgauge()}
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>    
          <Row>
            <Col md={7} style={{float:'left'}}>
              <table className='table table-sst-parking-car-doc-footer'>
                <tbody>
                  <tr>
                    <td>ชื่อ...................................................................................ผู้นำรถเข้าซ่อม</td>
                  </tr>
                  <tr>
                    <td>ชื่อ....................................................................................พนักงานตรวจ</td>
                  </tr>
                  <tr>
                    <td>ประมาณวันซ่อมรถเสร็จ............{receiving.appointment_date}................................</td>
                  </tr>
                  <tr>
                    <td>
                      <span className='color-pink' style={{fontSize:'16px'}}>*ให้ลูกค้ามาตรวจสอบรถก่อน ถ้าไม่เรียบร้อย*</span> ทางอู่จะแก้ไขให้ ถ้าท่านตรวจดู
                    </td>
                  </tr>
                  <tr>
                    <td>
                      รถแล้วเรียบร้อย ก็รับรถได้เลย กรุณานำใบรับรถมาด้วย
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
            <Col md={5} style={{float:'right'}}>
              <div className='box-remark-sst-parking-car-doc'>
                <div className='font-30'><u>หมายเหตุ</u></div>
                <div className=''>
                  เรียน ท่านเจ้าของรถทราบกรุณานำสิ่งของมีค่า
                </div>
                <div className=''>
                  ออกจากรถของท่าน เพราะทางอู่จะไม่รับ
                </div>
                <div className=''>
                  ผิดชอบการสูญหายใดๆ ทั้งสิ้น เมื่อได้อ่านข้อ
                </div>
                <div className=''>
                  ความเข้าใจแล้ว จึงได้ลงลายชื่อไว้เป็นหลักฐาน
                </div>
              </div>
            </Col>
          </Row>         
          <Row>
            <Col md={12}>
              <table className='table table-sst-parking-car-doc-footer'>
                <tbody>
                  <tr>
                    <td>
                      ติดต่อรับรถตั้งแต่ วันจันทร์-วันเสาร์ เวลา {this.renderOpenText(data)}
                    </td>
                  </tr>
                  <tr>
                    <td>
                      {this.renderExtraRemark(data)}
                    </td>
                  </tr>
                </tbody>
              </table>
            </Col>
          </Row>        
        </div>
      </div>
    )
  }

  onDamageRemarkSave(fieldInfo){
    let {data} = this.state
    let {remarklist} = data.related_detail
    remarklist[fieldInfo.index] = fieldInfo.value
    this.setState({data:data})
    this.saveParkingcarDoc(data)
  }

  onDamageRemarkClick(index){
    let {data} = this.state
    let {remarklist} = data.related_detail
    let fieldInfo = {title:'ใส่ข้อมูลตำหนิความเสียหายนอกเหนือใบเคลม',showClear:true,index:index,value:remarklist[index] }
    this.refs.textFieldModal.loadInfo(fieldInfo)
  }

  // onBodyDamageClick(position,index){
  //   let {data} = this.state
  //   let {body_damage_check} = data.related_detail
  //   body_damage_check[index].position = position
  //   this.setState({data:data})
  //   this.saveParkingcarDoc(data)
  // }

  onBodyDamageClick(position,index){
    let {data} = this.state
    let {body_damage_check} = data.related_detail
    if (body_damage_check[index].position==undefined) {
      body_damage_check[index] = {}
      body_damage_check[index] = Object.assign(body_damage_check[index], {position:position})
    } else {
      if (body_damage_check[index].position=='both')
        body_damage_check[index].position = position==='left'?'right':'left'
      else if (body_damage_check[index].position==position)
        body_damage_check[index].position = undefined
      else
        body_damage_check[index].position = 'both'
    }
    this.setState({data:data})
    this.saveParkingcarDoc(data)
  }

  // onDamageClick(flag,index){
  //   let {data} = this.state
  //   let {damage_check} = data.related_detail
  //   damage_check[index].normal = flag
  //   this.setState({data:data})
  //   this.saveParkingcarDoc(data)
  // }

  onDamageClick(flag,index){
    let {data} = this.state
    let {damage_check} = data.related_detail
    if (damage_check[index].normal==undefined) {
      damage_check[index] = {}
      damage_check[index] = Object.assign(damage_check[index], {normal:flag})
    } else {
      if (damage_check[index].normal==flag)
        damage_check[index].normal = undefined
      else
        damage_check[index].normal = flag
    }
    this.setState({data:data})
    this.saveParkingcarDoc(data)
  }

  // onAssetClick(flag,index){
  //   let {data} = this.state
  //   let {asset_check} = data.related_detail
  //   asset_check[index].exist = flag
  //   this.setState({data:data})
  //   this.saveParkingcarDoc(data)
  // }

  onAssetClick(flag,index) {
    let {data} = this.state
    let {asset_check} = data.related_detail
    if (asset_check[index].exist==undefined) {
      asset_check[index].exist = flag
    } else {
      if (asset_check[index].exist==flag)
      asset_check[index].exist = undefined
      else
      asset_check[index].exist = flag
    }
    this.setState({data:data})
    this.saveParkingcarDoc(data)
  }

  onAssetQuantityChange(index,e){
    let {data} = this.state
    let {asset_check} = data.related_detail

    asset_check[index].quantity = e.target.value
    this.setState({data:data})
    this.saveParkingcarDoc(data)
  }

  renderDamageRemark(text){
    if(text===''){
      return (<br />)
    }else{
      return text
    }
  }

  renderCarAsset(asset,asset_check,index) {
    return(
      <tr key={index}>
        <td>{asset==''?<br/>:asset}</td>
        <td className='text-center' onClick={this.onAssetClick.bind(this,true,index)}>{asset_check[index].exist!==undefined&&asset_check[index].exist?<FontAwesome name='check'/>:''}</td>
        <td style={{width:'20px'}} className='text-center'><FormControl onChange={this.onAssetQuantityChange.bind(this,index)} value={asset_check[index].quantity}/></td>
        <td className='text-center' onClick={this.onAssetClick.bind(this,false,index)}>{asset_check[index].exist!==undefined&&!asset_check[index].exist?<FontAwesome name='check'/>:''}</td>
      </tr>
    )
  }

  renderComponentPage2() {
    return(
      <div className='font-print'>
        <div className='box-sst-parking-car-doc-2'>
          <div className='font-40 text-center color-blue-sst-parking-car-doc'><u style={{textDecoration: 'underline dashed'}}>ระเบียบการนำรถเข้าซ่อม</u></div>
          <div>
            1.) กรณีที่รถยนต์มีน้ำมันมา ทางอู่ต้องทำการขับรถ เข้า-ออก โดยตลอด โดยเฉพาะรถที่เกิดเหตุ ซึ่งทางอู่ต้องนำรถไปซ่อม
          </div>
          <div>
            หรือทดลองขับรถ ดังนั้นทางอู่จึงขอความกรุณาในเรื่องของน้ำมัน กับเจ้าของรถด้วย
          </div>
          <br/>
          <div>
            2.) ในกรณีทีนำ่รถเข้าซ่อม บางครั้งรถไม่ได้ติดเครื่อง แบตเตอรี่อาจเสื่อมสภาพได้ ตามอายุการใช้งาน
          </div>
          <br/>
          <div>
            3.) เมื่อลูกค้าได้นำรถเข้ามาจอด <span className='color-pink'>"ขอความกรุณาเก็บสิ่งของทุกอย่างออกจากรถด้วย หากสิ่งของ ของท่านสูญหายทางอู่จะไม่</span>
          </div>
          <div className='color-pink'>รับผิดชอบ"</div>
          <br/>
          <div>
            4.) เมื่อลูกค้าได้นำรถเข้ามาซ่อมและมีอะไหล่ต้องสั่ง จากทางร้านหรือศูนย์บริการต่างๆ อาจเกิดความล่าช้า จึงขอความกรุณา
          </div>
          <div>
            ลูกค้าด้วย
          </div>
          <br/>
          <div>
            5.) ในกรณีทีนำ่รถเข้าซ่อม และเกิดความล่าช้าเกี่ยวกับวัน เวลา ที่อู่นัดมารับรถ ซึ่งเกิดจากที่อู่เอาไปทำซ่อมที่ศูนย์ต่างๆ ซึ่ง
          </div>
          <div>
            ทางอู่ไม่สามารถนัดลูกค้าได้ หรืออะไหล่อาจเกิดการติด BL/แบล็คลิส ทำให้รถเกิดความล่าช้า แต่หากท่านได้ทำการซ่อม
          </div>
          <div>
            เสร็จ ก่อนเวลากำหนดไว้ ทางอู่จะติดต่อลูกค้าให้มารับรถทันที
          </div>  
          <br/>
          <div>
            6.) กรณีที่รถซ่อมเสร็จ ทางอู่จะให้ลูกค้าตรวจดูรถก่อน ถ้าไม่เรียบร้อย ทางอู่ก็จะได้แก้ไขให้เรียบร้อย ถ้าลูกค้าดู
          </div>
          <div>
            แล้วว่าเรียบร้อย ลูกค้าสามารถขอรับรถกลับได้เลยทันที
          </div>
          <br/>
          <div> 
            7.) ในกรณีที่เกิดปัญหาภายหลังการซ่อม ทางอู่ยินดีทำการแก้ไขให้ กับลูกค้า เพื่อความพึงพอใจของลูกค้า
          </div>
          <br/>
          <div className='font-40 text-center color-blue-sst-parking-car-doc'><u style={{textDecoration: 'underline dashed'}}>เอกสารมารับรถ</u></div>
          <div>
            1.) รถประกัน ใช้เอกสาร ใบขับขี่, สำนำทะเบียนรถ,ตารางกรมธรรม์
          </div>
          <br/>
          <div>
            2.) รถคู่กรณี ใช้เอกสาร ใบขับขี่ผู้แจ้ง, บัตรประชาชนหรือใบขับขี่เจ้าของรถ, พรบ, สำนำทะเบียนรถ ถ้าไม่มีให้ใช้หนังสือซื้อ
          </div>
          <div>
            ขายรถ <span className='color-pink'>(ห้ามขาดบัตรประชาชนหรือใบขับขี่เจ้าของรถอย่างเด็ดขาด)</span>
          </div>
          <br/>
          <div>
            3.) ถ้ารถเป็นรถของบริษัท หรือ หจก.
          </div>          
          <div >            
              <span style={{marginLeft:'50px',marginRight:'25px'}}>- ใบรับรอง</span> <span style={{marginLeft:'50px'}}>- ตราประทับพร้อมลายเซ็นผู้มีอำนาจ</span><br/>
              <span style={{marginLeft:'50px'}}>- บัตรผู้มีอำนาจ</span> <span style={{marginLeft:'50px'}}>- ใบมอบอำนาจ</span>                        
          </div>
          <div className='font-40 text-center'><i className='color-pink'>ขอบคุณค่ะ</i></div>
        </div>
        <TextFieldModal ref='textFieldModal'
        confirmTitle='บันทึก'
        onConfirm={this.onDamageRemarkSave.bind(this)}
        />
        <NotificationSystem ref="notificationSystem" />
      </div>  
    )
  }
  
  render() {
    let {loading} = this.state
    let {mode,title} = this.props
    return(
      <PrintPreview 
        loading={loading} 
        leftBarTitle={mode==='2'?'ใบรับรถไม่จอดซ่อม ':title+' '+this.props.workNo}>
        {this.renderComponentPage()}
        {this.renderComponentPage2()}
      </PrintPreview>
    )
  }

}  

PrintSSTParkingCarDoc.defaultProps = {
  title: 'ใบรับรถเข้าซ่อม',  
  mode : '1'
}
export default PrintSSTParkingCarDoc;        


// WEBPACK FOOTER //
// ./src/view/print/sst/PrintSSTParkingCarDoc.js